import { graphql } from "gatsby"
import React, { useContext } from "react"

import { SiteContext } from "@context/Provider"
import CoreEmbed from "@molecules/CoreEmbed/CoreEmbed"

const VideoJwPlayer = ({ blockDataVideoJwPlayer }) => {
  const { jwplayer, caption } = blockDataVideoJwPlayer || {}

  const context = useContext(SiteContext)
  const jwPlayerIDs = context.jwPlayerIDs

  let jwPlayerIDsObject = {}

  if (jwPlayerIDs && Array.isArray(jwPlayerIDs)) {
    jwPlayerIDs.forEach((string) => {
      let array = string?.split("|")
      if (array.length === 2) {
        jwPlayerIDsObject[array[0]] = array[1]
      }
    })
  }

  return (
    <CoreEmbed
      captionText={caption}
      providerNameSlug="jwplayer"
      type="video"
      jwPlayerID={jwPlayerIDsObject[jwplayer]}
    />
  )
}

export const query = graphql`
  fragment VideoJwPlayer on WpBlockAcfVideoJwPlayer {
    __typename
    blockDataVideoJwPlayer {
      jwplayer
      caption
    }
  }
`

export default VideoJwPlayer
